import React, { useContext, useEffect } from "react";
import {
    BrowserRouter as Routers,
    Route,
    Routes,
    Navigate,
    useNavigate
} from "react-router-dom";

import { setNavigate } from "./Components/NavigateService/NavigateService.js";
import { AuthProvider, AuthContext } from "./Contexts/auth";
import LoadingIndicator from "./Components/LoadingIndicator/LoadingIndicator";
import HomePage from "./Pages/HomePage/HomePage";
import Login from "./Pages/Login/Login";
import ChangePassword from "./Pages/ChangePassword/FormChangePassword";
import Condominium from "./Pages/Condominium/Condominium";
import ConsumerUnit from "./Pages/ConsumerUnit/ConsumerUnit";
import Residents from "./Pages/Residents/Residents";
import Users from "./Pages/Users/Users";
import Plans from "./Pages/Plans/Plans";
import Rules from "./Pages/RulesControl/RulesControl";
import PedingRules from "./Pages/PedingRules/PedingRules";
import CreateAccount from "./Pages/CreateAccount/CreateAccount";
import PaymentsCreditCard from "./Pages/PaymentsCreditCard/PaymentsCreditCard.jsx";

const AppRoutes = () => {
    const navigate = useNavigate();

    useEffect(() => {
        setNavigate(navigate);
    }, [navigate]);

    const Private = ({ children }) => {
        const { authenticated, loading } = useContext(AuthContext);

        if (!authenticated) {
            return <Navigate to="/login" />;
        }

        if (loading || authenticated === null) {
            return (
                <div className="loading">
                    <LoadingIndicator loaded={false} colorSpinner={'#ffffff'} />
                </div>
            );
        }

        return children;
    };

    return (
        <AuthProvider>
            <Routes>
                <Route path="/" element={<HomePage />} />
                <Route path="/login" element={<Login />} />
                <Route path="/create-account" element={<CreateAccount />} />
                <Route path="/forgot-password" element={<ChangePassword />} />
                <Route path="/pending-rules" element={<Private><PedingRules /></Private>} />
                <Route path="/condominium" element={<Private><Condominium /></Private>} />
                <Route path="/users" element={<Private><Users /></Private>} />
                <Route path="/units" element={<Private><ConsumerUnit /></Private>} />
                <Route path="/residents" element={<Private><Residents /></Private>} />
                <Route path="/plans" element={<Private><Plans /></Private>} />
                <Route path="/rules" element={<Rules />} />
                <Route path="/checkout" element={<PaymentsCreditCard />} />
            </Routes>
        </AuthProvider>
    );
};

const AppRoutesWrapper = () => (
    <Routers>
        <AppRoutes />
    </Routers>
);

export default AppRoutesWrapper;
